import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_74x6c9zmb5: FaireBrandEntity = {
  token: "b_74x6c9zmb5",
  type: "brand",
  name: "DAYLA",
  avatarUrl:
    "https://cdn.faire.com/fastly/39d74e8d4af0ed5bff6e96661cd9822235210a123f023f6362298174ed182cac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/06cb524b8e83ba11a50b5c147aafcf10699ba87b231a050db4e3acfc53e63b50.png",
  logoUrl:
    "https://cdn.faire.com/fastly/39d74e8d4af0ed5bff6e96661cd9822235210a123f023f6362298174ed182cac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/06cb524b8e83ba11a50b5c147aafcf10699ba87b231a050db4e3acfc53e63b50.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 120,
  rating: 4.6,
  reviewCount: 34,
  isInsider: false,
  description:
    "Dayla is a colorful lifestyle boutique created to bring more joy into everyday moments.\n\nInspired by playful styling, cozy textures, and feel-good details, Dayla offers a curated mix of accessories, bags, jewelry, home accents, and giftable pieces designed to brighten daily life.\n\nFrom statement sunglasses and charm jewelry to cozy essentials and happy little finds, every collection is made to feel expressive, collectible, and easy to love.\n\nAt Dayla, we believe personal style should feel fun, approachable, and full of color — because sometimes the smallest things can make the biggest mood.\n\nTo better serve our customers, orders are fulfilled from multiple warehouses located in Los Angeles, New Jersey, and China, allowing us to offer a wider assortment of carefully curated products and faster shipping on select styles.\n\nWe also offer daily new drops, with fresh styles and new arrivals added regularly.\n\nFor easier browsing, we recommend exploring our curated collection lists to discover products by mood, category, and everyday moments.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:19.355Z",
    importedBy: "entity-db-cli",
  },
};
